import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "dsvm_lang";
export const LANGS = [
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "sr", label: "SR" },
  { code: "fr", label: "FR" },
];
export const DEFAULT_LANG = "en";

export const TR = {
  en: {
    "nav.home": "Home", "nav.services": "Services", "nav.references": "References",
    "nav.about": "About", "nav.contact": "Contact",
    "cta.request_quote": "Request a quote", "cta.our_services": "Our services",
    "cta.back_to_site": "← Back to website",
    "label.slovenia_eu": "Slovenia · All of EU", "label.what_we_do": "— What we do",
    "label.references": "— References", "label.why_us": "— Why DSVM Group",
    "label.ready": "— Ready for your next project?", "label.services": "— Services",
    "label.about": "— About us", "label.contact": "— Contact",
    "label.where_we_work": "— Where we work",
    "hero.title_part1": "Experts in", "hero.title_part2": "industrial",
    "hero.title_part3": "and residential", "hero.title_part4": "electrical installations",
    "hero.desc": "From factories in Germany to data centers in Luxembourg — DSVM Group designs and delivers complex electrical, data and security systems across the European Union.",
    "stats.years": "Years of experience", "stats.projects": "Completed projects",
    "stats.countries": "EU countries", "stats.support": "Technical support",
    "services.headline": "Six areas where we are strongest.",
    "services.desc": "From design to service — we deliver end-to-end solutions for industrial and business clients.",
    "services.title": "What DSVM Group does for you.",
    "services.subtitle": "We provide a complete solution from design through execution to service. Whether it's an industrial hall in Germany or a villa in Luxembourg — our team brings power, data and security under one roof.",
    "projects.headline": "Projects that keep the power on.",
    "projects.subtitle": "An overview of selected projects from industry, data infrastructure and security systems across the EU.",
    "projects.all": "All", "projects.cta": "View all references",
    "projects.client": "Client:",
    "about.headline_part1": "Slovenian", "about.headline_part2": "precision",
    "about.headline_part3": ", European", "about.headline_part4": "reach",
    "about.p1": "DSVM Group is a Slovenian electrical contracting company founded with a focus on complex industrial and commercial projects. Over the years our team has expanded operations across the European Union — from the Netherlands through Germany to Luxembourg.",
    "about.p2": "We specialize in industrial installations, data infrastructure, security systems, access control and CCTV. We also work in the private segment — smart homes and luxury buildings.",
    "about.p3": "Our approach is quiet, precise, and fully compliant with EU standards (VDE, NEN, IEC). Every project is led by an engineer with a minimum 10 years of experience.",
    "about.active_in": "Active in {n} EU countries.",
    "values.safety": "Safety", "values.safety_desc": "Standard > compromise. Always.",
    "values.certified": "Certifications", "values.certified_desc": "EU compliant execution and documentation.",
    "values.team": "Experienced team", "values.team_desc": "Engineers and installers with decades of practice.",
    "values.coverage": "EU coverage", "values.coverage_desc": "Mobile team, fast response in 8 countries.",
    "why.title_line1": "A quiet contractor behind", "why.title_line2": "quiet systems.",
    "why.desc": "Our team works where it must be done precisely — in production halls, underground parking, data centers and private villas. No improvisation, no compromise on standards.",
    "why.eu_certs": "EU certifications", "why.eu_certs_desc": "VDE, NEN 1010, IEC compliant execution.",
    "why.deadlines": "Deadlines we keep", "why.deadlines_desc": "Defined project management on every project.",
    "why.team": "Experienced team", "why.team_desc": "Engineers and installers with 10+ years experience.",
    "why.eu_cov": "EU coverage", "why.eu_cov_desc": "Mobile team based in Slovenia, active in 8 countries.",
    "cta_section.line1": "Send your inquiry.", "cta_section.line2": "We take it from here.",
    "cta_section.desc": "Estimate and consultation at no charge. We respond within 24h on business days.",
    "contact.title_line1": "Send an inquiry.", "contact.title_line2": "We come back with a quote.",
    "contact.desc": "Free consultation, on-site visit and project estimate. We respond within 24 hours on business days.",
    "contact.phone": "Phone", "contact.email": "Email", "contact.address": "Headquarters",
    "contact.coverage": "Coverage", "contact.active_countries": "Active in: {countries}.",
    "form.name": "Full name *", "form.email": "Email *", "form.phone": "Phone",
    "form.company": "Company", "form.country": "Project country", "form.service": "Service",
    "form.message": "Project description / message *", "form.choose": "Choose...",
    "form.submit": "Send inquiry", "form.gdpr": "By submitting you agree to the processing of your data for contact purposes. We do not share your data with third parties.",
    "form.success_title": "Inquiry sent!",
    "form.success_desc": "Thank you. Our team will contact you as soon as possible — usually within 24h on business days.",
    "form.send_another": "Send another inquiry",
    "form.success_toast": "Thank you! Your inquiry has been sent. We'll respond within 24h.",
    "form.error_required": "Please fill in required fields: name, email and message.",
    "form.error_send": "Error sending. Please try again or call us directly.",
    "footer.tagline": "Leading Slovenian firm for industrial and residential electrical installations, data infrastructure, security systems and CCTV — serving clients across the European Union.",
    "footer.navigation": "Navigation", "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "footer.privacy": "Privacy Policy",
    "footer.iso": "EU · ISO compliant · Certified contractors",
    "service.industrial": "Industrial installations",
    "service.industrial_short": "Complete electrical installation of production plants, factories and industrial facilities.",
    "service.home": "Residential installations",
    "service.home_short": "Residential electrical installations and smart home (KNX).",
    "service.data": "Data & Networks",
    "service.data_short": "Structured cabling, fiber and server room solutions for business clients.",
    "service.security": "Security systems",
    "service.security_short": "Integrated alarm and fire systems with 24/7 monitoring.",
    "service.access": "Access control",
    "service.access_short": "RFID, biometrics and integration with HR systems for access management.",
    "service.cctv": "CCTV / Video surveillance",
    "service.cctv_short": "IP cameras with AI analytics, NVR systems and 24/7 remote monitoring.",
    "projects.title_part1": "Projects that", "projects.title_part2": "keep the power on.",
    "projects.intro": "An overview of selected projects from industry, data infrastructure and security systems across the EU.",
    "projects.our_europe": "— Our Europe",
    "projects.map_hint": "Click a gold dot for project info. Zoom and pan the map for a detailed view.",
    "projects.empty_category": "No projects in this category.",
    "projects.loading": "Loading...",
    "map.eu_operations": "DSVM Group · EU Operations",
    "map.active_locations": "{n} active locations",
    "map.cta_view": "View project →",
    "map.client": "Client:",
    "home.years_badge": "Years in EU industry",
    "chat.greeting": "Welcome! I'm the DSVM Group AI assistant. How can I help you with electrical installations, security systems or CCTV?",
    "chat.error": "Sorry, an error occurred. Please try again or call us.",
    "chat.title": "AI Assistant", "chat.live": "DSVM Group · live",
    "chat.placeholder": "Ask a question...",
    "detail.back": "All references",
    "detail.scope": "Scope of work",
    "detail.locations": "Locations",
    "detail.cta": "Similar project? Contact us",
    "ai.draft_btn": "✨ AI suggestion",
    "ai.draft_hint": "Type a few keywords, click to generate a full report.",
    "ai.draft_done": "AI draft generated. Edit if needed.",
    "ai.draft_error": "AI couldn't generate. Try with more details.",
  },
  de: {
    "nav.home": "Startseite", "nav.services": "Leistungen", "nav.references": "Referenzen",
    "nav.about": "Über uns", "nav.contact": "Kontakt",
    "cta.request_quote": "Angebot anfordern", "cta.our_services": "Unsere Leistungen",
    "cta.back_to_site": "← Zurück zur Website",
    "label.slovenia_eu": "Slowenien · Ganze EU", "label.what_we_do": "— Was wir tun",
    "label.references": "— Referenzen", "label.why_us": "— Warum DSVM Group",
    "label.ready": "— Bereit für das nächste Projekt?", "label.services": "— Leistungen",
    "label.about": "— Über uns", "label.contact": "— Kontakt",
    "label.where_we_work": "— Wo wir arbeiten",
    "hero.title_part1": "Experten für", "hero.title_part2": "industrielle",
    "hero.title_part3": "und private", "hero.title_part4": "Elektroinstallationen",
    "hero.desc": "Von Fabriken in Deutschland bis zu Rechenzentren in Luxemburg — DSVM Group plant und realisiert komplexe Elektro-, Daten- und Sicherheitssysteme in der gesamten EU.",
    "stats.years": "Jahre Erfahrung", "stats.projects": "Abgeschlossene Projekte",
    "stats.countries": "EU-Länder", "stats.support": "Technischer Support",
    "services.headline": "Sechs Bereiche, in denen wir am stärksten sind.",
    "services.desc": "Von der Planung bis zum Service — End-to-End-Lösungen für Industrie- und Geschäftskunden.",
    "services.title": "Was DSVM Group für Sie tut.",
    "services.subtitle": "Wir bieten Komplettlösungen von der Planung über die Ausführung bis zum Service. Ob Industriehalle in Deutschland oder Villa in Luxemburg — unser Team bringt Strom, Daten und Sicherheit unter ein Dach.",
    "projects.headline": "Projekte, die unter Strom stehen.",
    "projects.subtitle": "Eine Auswahl an Projekten aus Industrie, Dateninfrastruktur und Sicherheitssystemen in der gesamten EU.",
    "projects.all": "Alle", "projects.cta": "Alle Referenzen ansehen",
    "projects.client": "Kunde:",
    "about.headline_part1": "Slowenische", "about.headline_part2": "Präzision",
    "about.headline_part3": ", europäische", "about.headline_part4": "Reichweite",
    "about.p1": "DSVM Group ist ein slowenisches Elektroinstallationsunternehmen mit Fokus auf komplexe Industrie- und Gewerbeprojekte. Im Laufe der Jahre hat unser Team die Tätigkeiten in der gesamten EU ausgeweitet — von den Niederlanden über Deutschland bis nach Luxemburg.",
    "about.p2": "Wir sind spezialisiert auf Industrieinstallationen, Dateninfrastruktur, Sicherheitssysteme, Zutrittskontrolle und Videoüberwachung. Auch im Privatbereich sind wir tätig — Smart Homes und Luxusobjekte.",
    "about.p3": "Unser Ansatz ist diskret, präzise und vollständig konform mit EU-Normen (VDE, NEN, IEC). Jedes Projekt wird von einem Ingenieur mit mindestens 10 Jahren Erfahrung geleitet.",
    "about.active_in": "Aktiv in {n} EU-Ländern.",
    "values.safety": "Sicherheit", "values.safety_desc": "Norm > Kompromiss. Immer.",
    "values.certified": "Zertifikate", "values.certified_desc": "EU-konforme Ausführung und Dokumentation.",
    "values.team": "Erfahrenes Team", "values.team_desc": "Ingenieure und Monteure mit jahrzehntelanger Praxis.",
    "values.coverage": "EU-Abdeckung", "values.coverage_desc": "Mobiles Team, schnelle Reaktion in 8 Ländern.",
    "why.title_line1": "Stiller Auftragnehmer hinter", "why.title_line2": "stillen Systemen.",
    "why.desc": "Unser Team arbeitet dort, wo es präzise sein muss — in Produktionshallen, Tiefgaragen, Rechenzentren und Privatvillen. Keine Improvisation, keine Kompromisse bei Normen.",
    "why.eu_certs": "EU-Zertifizierung", "why.eu_certs_desc": "VDE-, NEN 1010-, IEC-konforme Ausführung.",
    "why.deadlines": "Eingehaltene Fristen", "why.deadlines_desc": "Definiertes Projektmanagement bei jedem Projekt.",
    "why.team": "Erfahrenes Team", "why.team_desc": "Ingenieure und Monteure mit 10+ Jahren Erfahrung.",
    "why.eu_cov": "EU-Abdeckung", "why.eu_cov_desc": "Mobiles Team mit Sitz in Slowenien, aktiv in 8 Ländern.",
    "cta_section.line1": "Senden Sie Ihre Anfrage.", "cta_section.line2": "Wir übernehmen den Rest.",
    "cta_section.desc": "Schätzung und Beratung kostenlos. Antwort innerhalb von 24h an Werktagen.",
    "contact.title_line1": "Senden Sie eine Anfrage.", "contact.title_line2": "Wir antworten mit einem Angebot.",
    "contact.desc": "Kostenlose Beratung, Vor-Ort-Termin und Projektschätzung. Wir antworten innerhalb von 24 Stunden an Werktagen.",
    "contact.phone": "Telefon", "contact.email": "E-Mail", "contact.address": "Hauptsitz",
    "contact.coverage": "Abdeckung", "contact.active_countries": "Aktiv in: {countries}.",
    "form.name": "Vor- und Nachname *", "form.email": "E-Mail *", "form.phone": "Telefon",
    "form.company": "Firma", "form.country": "Projektland", "form.service": "Leistung",
    "form.message": "Projektbeschreibung / Nachricht *", "form.choose": "Auswählen...",
    "form.submit": "Anfrage senden", "form.gdpr": "Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Daten zu Kontaktzwecken zu. Wir geben Ihre Daten nicht an Dritte weiter.",
    "form.success_title": "Anfrage gesendet!",
    "form.success_desc": "Vielen Dank. Unser Team meldet sich so bald wie möglich — in der Regel innerhalb von 24h an Werktagen.",
    "form.send_another": "Weitere Anfrage senden",
    "form.success_toast": "Danke! Ihre Anfrage wurde gesendet. Wir antworten innerhalb von 24h.",
    "form.error_required": "Bitte füllen Sie die Pflichtfelder aus: Name, E-Mail und Nachricht.",
    "form.error_send": "Sendefehler. Bitte versuchen Sie es erneut oder rufen Sie uns direkt an.",
    "footer.tagline": "Führendes slowenisches Unternehmen für industrielle und private Elektroinstallationen, Dateninfrastruktur, Sicherheitssysteme und Videoüberwachung — im Dienst von Kunden in der gesamten Europäischen Union.",
    "footer.navigation": "Navigation", "footer.contact": "Kontakt",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.privacy": "Datenschutz",
    "footer.iso": "EU · ISO-konform · Zertifizierte Auftragnehmer",
    "service.industrial": "Industrieinstallationen",
    "service.industrial_short": "Komplette Elektroinstallation von Produktionsanlagen, Fabriken und Industrieobjekten.",
    "service.home": "Privatinstallationen",
    "service.home_short": "Wohninstallationen und Smart Home (KNX).",
    "service.data": "Daten & Netzwerke",
    "service.data_short": "Strukturierte Verkabelung, Glasfaser und Serverraum-Lösungen für Geschäftskunden.",
    "service.security": "Sicherheitssysteme",
    "service.security_short": "Integrierte Alarm- und Brandmeldesysteme mit 24/7-Überwachung.",
    "service.access": "Zutrittskontrolle",
    "service.access_short": "RFID, Biometrie und Integration mit HR-Systemen zur Zugangsverwaltung.",
    "service.cctv": "Videoüberwachung",
    "service.cctv_short": "IP-Kameras mit KI-Analyse, NVR-Systeme und 24/7-Fernüberwachung.",
    "projects.title_part1": "Projekte, die", "projects.title_part2": "unter Strom stehen.",
    "projects.intro": "Eine Auswahl an Projekten aus Industrie, Dateninfrastruktur und Sicherheitssystemen in der gesamten EU.",
    "projects.our_europe": "— Unser Europa",
    "projects.map_hint": "Klicken Sie auf einen goldenen Punkt für Projektinformationen. Zoomen und verschieben Sie die Karte für eine detaillierte Ansicht.",
    "projects.empty_category": "Keine Projekte in dieser Kategorie.",
    "projects.loading": "Lädt...",
    "map.eu_operations": "DSVM Group · EU-Aktivitäten",
    "map.active_locations": "{n} aktive Standorte",
    "map.cta_view": "Projekt ansehen →",
    "map.client": "Kunde:",
    "home.years_badge": "Jahre in EU-Industrie",
    "chat.greeting": "Willkommen! Ich bin der DSVM Group KI-Assistent. Wie kann ich Ihnen bei Elektroinstallationen, Sicherheitssystemen oder Videoüberwachung helfen?",
    "chat.error": "Entschuldigung, ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder rufen Sie uns an.",
    "chat.title": "KI-Assistent", "chat.live": "DSVM Group · live",
    "chat.placeholder": "Stellen Sie eine Frage...",
    "detail.back": "Alle Referenzen",
    "detail.scope": "Leistungsumfang",
    "detail.locations": "Standorte",
    "detail.cta": "Ähnliches Projekt? Kontaktieren Sie uns",
    "ai.draft_btn": "✨ KI-Vorschlag",
    "ai.draft_hint": "Geben Sie ein paar Stichworte ein, klicken Sie zum Generieren.",
    "ai.draft_done": "KI-Entwurf erstellt. Bei Bedarf bearbeiten.",
    "ai.draft_error": "KI konnte nichts erzeugen. Versuchen Sie mit mehr Details.",
  },
  sr: {
    "nav.home": "Početna", "nav.services": "Usluge", "nav.references": "Reference",
    "nav.about": "O nama", "nav.contact": "Kontakt",
    "cta.request_quote": "Zatražite ponudu", "cta.our_services": "Naše usluge",
    "cta.back_to_site": "← Nazad na sajt",
    "label.slovenia_eu": "Slovenija · Cela EU", "label.what_we_do": "— Šta radimo",
    "label.references": "— Reference", "label.why_us": "— Zašto DSVM Group",
    "label.ready": "— Spremni za sledeći projekat?", "label.services": "— Usluge",
    "label.about": "— O nama", "label.contact": "— Kontakt",
    "label.where_we_work": "— Gde radimo",
    "hero.title_part1": "Eksperti za", "hero.title_part2": "industrijske",
    "hero.title_part3": "i kućne", "hero.title_part4": "elektroinstalacije",
    "hero.desc": "Od fabrika u Nemačkoj do data centara u Luksemburgu — DSVM Group projektuje i izvodi kompleksne elektro, data i sigurnosne sisteme širom EU.",
    "stats.years": "Godina iskustva", "stats.projects": "Završenih projekata",
    "stats.countries": "EU zemalja", "stats.support": "Tehnička podrška",
    "services.headline": "Šest oblasti gde smo najjači.",
    "services.desc": "Od projektovanja do servisa — pružamo end-to-end rešenja za industrijske i poslovne klijente.",
    "services.title": "Šta DSVM Group radi za vas.",
    "services.subtitle": "Pružamo kompletno rešenje od projektovanja preko izvođenja do servisa. Bilo da je u pitanju industrijska hala u Nemačkoj ili vila u Luksemburgu — naš tim donosi struju, podatke i sigurnost pod jedan krov.",
    "projects.headline": "Projekti koji drže struju.",
    "projects.subtitle": "Pregled odabranih projekata iz industrije, data infrastrukture i sigurnosnih sistema širom EU.",
    "projects.all": "Svi", "projects.cta": "Sve reference",
    "projects.client": "Klijent:",
    "about.headline_part1": "Slovenska", "about.headline_part2": "preciznost",
    "about.headline_part3": ", evropski", "about.headline_part4": "domet",
    "about.p1": "DSVM Group je slovenska elektroinstalaterska firma osnovana sa fokusom na složene industrijske i poslovne projekte. Tokom godina, naša ekipa je proširila delovanje na ceo prostor Evropske unije — od Holandije preko Nemačke do Luksemburga.",
    "about.p2": "Specijalizovani smo za industrijske instalacije, data infrastrukturu, sigurnosne sisteme, kontrolu pristupa i video nadzor. Radimo i u privatnom segmentu — pametne kuće i luksuzni objekti.",
    "about.p3": "Naš pristup je tih, precizan i potpuno u skladu sa EU normama (VDE, NEN, IEC). Svaki projekat vodi inženjer sa minimum 10 godina iskustva.",
    "about.active_in": "Aktivni u {n} EU zemalja.",
    "values.safety": "Sigurnost", "values.safety_desc": "Norma > kompromis. Uvek.",
    "values.certified": "Sertifikati", "values.certified_desc": "EU compliant izvođenje i dokumentacija.",
    "values.team": "Iskusni tim", "values.team_desc": "Inženjeri i monteri sa decenijama prakse.",
    "values.coverage": "EU pokrivenost", "values.coverage_desc": "Mobilna ekipa, brz odziv u 8 zemalja.",
    "why.title_line1": "Tihi izvođač iza", "why.title_line2": "tihih sistema.",
    "why.desc": "Naš tim radi tamo gde se mora raditi precizno — u proizvodnim halama, podzemnim garažama, data centrima i privatnim vilama. Bez improvizacije, bez kompromisa po pitanju normativa.",
    "why.eu_certs": "EU sertifikati", "why.eu_certs_desc": "VDE, NEN 1010, IEC compliant izvođenje.",
    "why.deadlines": "Rokovi koji se drže", "why.deadlines_desc": "Definisan project management na svakom projektu.",
    "why.team": "Iskusan tim", "why.team_desc": "Inženjeri i monteri sa 10+ godina iskustva.",
    "why.eu_cov": "EU pokrivenost", "why.eu_cov_desc": "Mobilna ekipa sa bazom u Sloveniji, aktivni u 8 zemalja.",
    "cta_section.line1": "Pošaljite upit.", "cta_section.line2": "Mi radimo dalje.",
    "cta_section.desc": "Procena i konsultacije bez naknade. Odgovaramo u roku od 24h radnim danima.",
    "contact.title_line1": "Pošaljite upit.", "contact.title_line2": "Mi vraćamo ponudu.",
    "contact.desc": "Besplatne konsultacije, izlazak na teren i procena projekta. Odgovaramo u roku od 24 sata radnim danima.",
    "contact.phone": "Telefon", "contact.email": "Email", "contact.address": "Sedište",
    "contact.coverage": "Pokrivenost", "contact.active_countries": "Aktivni u: {countries}.",
    "form.name": "Ime i prezime *", "form.email": "Email *", "form.phone": "Telefon",
    "form.company": "Firma", "form.country": "Država projekta", "form.service": "Usluga",
    "form.message": "Opis projekta / poruka *", "form.choose": "Izaberite...",
    "form.submit": "Pošaljite upit", "form.gdpr": "Slanjem upita pristajete na obradu podataka u svrhu kontakta. Vaše podatke ne delimo sa trećim licima.",
    "form.success_title": "Upit poslat!",
    "form.success_desc": "Hvala vam. Naš tim će vas kontaktirati u najkraćem mogućem roku — obično u roku od 24h radnim danima.",
    "form.send_another": "Pošaljite još jedan upit",
    "form.success_toast": "Hvala! Vaš upit je poslat. Javljamo se u roku od 24h.",
    "form.error_required": "Molimo popunite obavezna polja: ime, email i poruku.",
    "form.error_send": "Greška pri slanju. Molimo pokušajte ponovo ili nas pozovite direktno.",
    "footer.tagline": "Vodeća slovenačka firma za industrijske i kućne elektroinstalacije, data infrastrukturu, sigurnosne sisteme i video nadzor — u službi klijenata širom Evropske unije.",
    "footer.navigation": "Navigacija", "footer.contact": "Kontakt",
    "footer.rights": "Sva prava zadržana.",
    "footer.privacy": "Politika privatnosti",
    "footer.iso": "EU · ISO compliant · Sertifikovani izvođači",
    "service.industrial": "Industrijske instalacije",
    "service.industrial_short": "Kompletna elektroinstalacija proizvodnih pogona, fabrika i industrijskih objekata.",
    "service.home": "Kućne instalacije",
    "service.home_short": "Stambene elektroinstalacije i pametna kuća (smart home, KNX).",
    "service.data": "Data & Mreže",
    "service.data_short": "Strukturno kabliranje, optika i server room rešenja za poslovne korisnike.",
    "service.security": "Sigurnosni sistemi",
    "service.security_short": "Integrisani alarmni i protivpožarni sistemi sa 24/7 monitoringom.",
    "service.access": "Kontrola pristupa",
    "service.access_short": "RFID, biometrija i integracija sa HR sistemima za upravljanje pristupom.",
    "service.cctv": "Video nadzor",
    "service.cctv_short": "IP kamere sa AI analitikom, NVR sistemi i 24/7 daljinski monitoring.",
    "projects.title_part1": "Projekti koji", "projects.title_part2": "drže struju.",
    "projects.intro": "Pregled odabranih projekata iz industrije, data infrastrukture i sigurnosnih sistema širom EU.",
    "projects.our_europe": "— Naša Evropa",
    "projects.map_hint": "Kliknite zlatnu tačku za informacije o projektu. Zumirajte i pomerajte mapu za detaljniji pregled.",
    "projects.empty_category": "Nema projekata u ovoj kategoriji.",
    "projects.loading": "Učitavanje...",
    "map.eu_operations": "DSVM Group · EU Operacije",
    "map.active_locations": "{n} aktivnih lokacija",
    "map.cta_view": "Pogledaj projekat →",
    "map.client": "Klijent:",
    "home.years_badge": "u EU industriji",
    "chat.greeting": "Dobrodošli! Ja sam AI asistent DSVM Group. Kako vam mogu pomoći u vezi elektroinstalacija, sigurnosnih sistema ili video nadzora?",
    "chat.error": "Izvinjavamo se, došlo je do greške. Pokušajte ponovo ili nas pozovite.",
    "chat.title": "AI Asistent", "chat.live": "DSVM Group · uživo",
    "chat.placeholder": "Postavite pitanje...",
    "detail.back": "Sve reference",
    "detail.scope": "Obim radova",
    "detail.locations": "Lokacije",
    "detail.cta": "Sličan projekat? Kontaktirajte nas",
    "ai.draft_btn": "✨ AI predlog",
    "ai.draft_hint": "Unesi par ključnih reči, klikni za generisanje izveštaja.",
    "ai.draft_done": "AI predlog generisan. Možeš da menjaš ako treba.",
    "ai.draft_error": "AI nije uspeo da generiše. Pokušaj sa više detalja.",
  },
  fr: {
    "nav.home": "Accueil", "nav.services": "Services", "nav.references": "Références",
    "nav.about": "À propos", "nav.contact": "Contact",
    "cta.request_quote": "Demander un devis", "cta.our_services": "Nos services",
    "cta.back_to_site": "← Retour au site",
    "label.slovenia_eu": "Slovénie · Toute l'UE", "label.what_we_do": "— Ce que nous faisons",
    "label.references": "— Références", "label.why_us": "— Pourquoi DSVM Group",
    "label.ready": "— Prêt pour votre prochain projet ?", "label.services": "— Services",
    "label.about": "— À propos", "label.contact": "— Contact",
    "label.where_we_work": "— Où nous travaillons",
    "hero.title_part1": "Experts en", "hero.title_part2": "installations",
    "hero.title_part3": "électriques", "hero.title_part4": "industrielles et résidentielles",
    "hero.desc": "Des usines en Allemagne aux centres de données au Luxembourg — DSVM Group conçoit et réalise des systèmes électriques, de données et de sécurité complexes dans toute l'UE.",
    "stats.years": "Années d'expérience", "stats.projects": "Projets réalisés",
    "stats.countries": "Pays de l'UE", "stats.support": "Support technique",
    "services.headline": "Six domaines où nous excellons.",
    "services.desc": "De la conception au service — solutions end-to-end pour clients industriels et professionnels.",
    "services.title": "Ce que DSVM Group fait pour vous.",
    "services.subtitle": "Nous offrons une solution complète de la conception à l'exécution et au service. Qu'il s'agisse d'une halle industrielle en Allemagne ou d'une villa au Luxembourg — notre équipe apporte l'électricité, les données et la sécurité sous un même toit.",
    "projects.headline": "Projets qui maintiennent le courant.",
    "projects.subtitle": "Un aperçu de projets sélectionnés dans l'industrie, l'infrastructure de données et les systèmes de sécurité à travers l'UE.",
    "projects.all": "Tous", "projects.cta": "Toutes les références",
    "projects.client": "Client :",
    "about.headline_part1": "Précision", "about.headline_part2": "slovène",
    "about.headline_part3": ", portée", "about.headline_part4": "européenne",
    "about.p1": "DSVM Group est une entreprise slovène d'installations électriques fondée avec un focus sur les projets industriels et commerciaux complexes. Au fil des années, notre équipe a étendu ses activités à toute l'Union européenne — des Pays-Bas à l'Allemagne en passant par le Luxembourg.",
    "about.p2": "Nous sommes spécialisés dans les installations industrielles, l'infrastructure de données, les systèmes de sécurité, le contrôle d'accès et la vidéosurveillance. Nous travaillons également dans le segment privé — maisons intelligentes et bâtiments de luxe.",
    "about.p3": "Notre approche est discrète, précise et entièrement conforme aux normes européennes (VDE, NEN, IEC). Chaque projet est dirigé par un ingénieur ayant au moins 10 ans d'expérience.",
    "about.active_in": "Actifs dans {n} pays de l'UE.",
    "values.safety": "Sécurité", "values.safety_desc": "Norme > compromis. Toujours.",
    "values.certified": "Certifications", "values.certified_desc": "Exécution et documentation conformes UE.",
    "values.team": "Équipe expérimentée", "values.team_desc": "Ingénieurs et installateurs avec des décennies de pratique.",
    "values.coverage": "Couverture UE", "values.coverage_desc": "Équipe mobile, réponse rapide dans 8 pays.",
    "why.title_line1": "Un entrepreneur discret derrière", "why.title_line2": "des systèmes discrets.",
    "why.desc": "Notre équipe travaille là où la précision est essentielle — halls de production, parkings souterrains, centres de données et villas privées. Pas d'improvisation, pas de compromis sur les normes.",
    "why.eu_certs": "Certifications UE", "why.eu_certs_desc": "Exécution conforme VDE, NEN 1010, IEC.",
    "why.deadlines": "Délais respectés", "why.deadlines_desc": "Gestion de projet définie pour chaque projet.",
    "why.team": "Équipe expérimentée", "why.team_desc": "Ingénieurs et installateurs avec 10+ ans d'expérience.",
    "why.eu_cov": "Couverture UE", "why.eu_cov_desc": "Équipe mobile basée en Slovénie, active dans 8 pays.",
    "cta_section.line1": "Envoyez votre demande.", "cta_section.line2": "Nous prenons le relais.",
    "cta_section.desc": "Estimation et consultation gratuites. Réponse sous 24h les jours ouvrables.",
    "contact.title_line1": "Envoyez une demande.", "contact.title_line2": "Nous répondons avec un devis.",
    "contact.desc": "Consultation gratuite, visite sur site et estimation de projet. Réponse sous 24 heures les jours ouvrables.",
    "contact.phone": "Téléphone", "contact.email": "E-mail", "contact.address": "Siège social",
    "contact.coverage": "Couverture", "contact.active_countries": "Actifs en : {countries}.",
    "form.name": "Nom et prénom *", "form.email": "E-mail *", "form.phone": "Téléphone",
    "form.company": "Entreprise", "form.country": "Pays du projet", "form.service": "Service",
    "form.message": "Description du projet / message *", "form.choose": "Choisir...",
    "form.submit": "Envoyer la demande", "form.gdpr": "En soumettant, vous acceptez le traitement de vos données à des fins de contact. Nous ne partageons pas vos données avec des tiers.",
    "form.success_title": "Demande envoyée !",
    "form.success_desc": "Merci. Notre équipe vous contactera dès que possible — généralement sous 24h les jours ouvrables.",
    "form.send_another": "Envoyer une autre demande",
    "form.success_toast": "Merci ! Votre demande a été envoyée. Nous répondrons sous 24h.",
    "form.error_required": "Veuillez remplir les champs obligatoires : nom, e-mail et message.",
    "form.error_send": "Erreur d'envoi. Veuillez réessayer ou nous appeler directement.",
    "footer.tagline": "Entreprise slovène de premier plan pour installations électriques industrielles et résidentielles, infrastructure de données, systèmes de sécurité et vidéosurveillance — au service de clients dans toute l'Union européenne.",
    "footer.navigation": "Navigation", "footer.contact": "Contact",
    "footer.rights": "Tous droits réservés.",
    "footer.privacy": "Confidentialité",
    "footer.iso": "UE · Conforme ISO · Entrepreneurs certifiés",
    "service.industrial": "Installations industrielles",
    "service.industrial_short": "Installation électrique complète d'usines, fabriques et bâtiments industriels.",
    "service.home": "Installations résidentielles",
    "service.home_short": "Installations électriques résidentielles et maison intelligente (KNX).",
    "service.data": "Données & Réseaux",
    "service.data_short": "Câblage structuré, fibre optique et solutions de salle serveurs pour clients professionnels.",
    "service.security": "Systèmes de sécurité",
    "service.security_short": "Systèmes d'alarme et anti-incendie intégrés avec surveillance 24/7.",
    "service.access": "Contrôle d'accès",
    "service.access_short": "RFID, biométrie et intégration aux systèmes RH pour la gestion des accès.",
    "service.cctv": "Vidéosurveillance",
    "service.cctv_short": "Caméras IP avec analyse IA, systèmes NVR et surveillance à distance 24/7.",
    "projects.title_part1": "Des projets qui", "projects.title_part2": "maintiennent le courant.",
    "projects.intro": "Un aperçu de projets sélectionnés dans l'industrie, l'infrastructure de données et les systèmes de sécurité à travers l'UE.",
    "projects.our_europe": "— Notre Europe",
    "projects.map_hint": "Cliquez sur un point doré pour les informations du projet. Zoomez et déplacez la carte pour une vue détaillée.",
    "projects.empty_category": "Aucun projet dans cette catégorie.",
    "projects.loading": "Chargement...",
    "map.eu_operations": "DSVM Group · Opérations UE",
    "map.active_locations": "{n} sites actifs",
    "map.cta_view": "Voir le projet →",
    "map.client": "Client :",
    "home.years_badge": "ans dans l'industrie UE",
    "chat.greeting": "Bienvenue ! Je suis l'assistant IA de DSVM Group. Comment puis-je vous aider concernant les installations électriques, les systèmes de sécurité ou la vidéosurveillance ?",
    "chat.error": "Désolé, une erreur s'est produite. Veuillez réessayer ou nous appeler.",
    "chat.title": "Assistant IA", "chat.live": "DSVM Group · en direct",
    "chat.placeholder": "Posez une question...",
    "detail.back": "Toutes les références",
    "detail.scope": "Étendue des travaux",
    "detail.locations": "Sites",
    "detail.cta": "Projet similaire ? Contactez-nous",
    "ai.draft_btn": "✨ Suggestion IA",
    "ai.draft_hint": "Saisissez quelques mots-clés, cliquez pour générer.",
    "ai.draft_done": "Brouillon IA généré. Modifiez si nécessaire.",
    "ai.draft_error": "L'IA n'a pas pu générer. Essayez avec plus de détails.",
  },
};

const I18nContext = createContext(null);

/**
 * Detect best initial language for first-time visitor:
 * 1. saved preference (localStorage)
 * 2. browser locale (navigator.languages → first match against EN/DE/SR/FR)
 * 3. DEFAULT_LANG fallback
 */
function detectInitialLang() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && LANGS.some((l) => l.code === saved)) return saved;

  const supported = LANGS.map((l) => l.code);
  const candidates = (navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language || ""];

  for (const c of candidates) {
    const base = (c || "").toLowerCase().split("-")[0];
    // Map common variants
    if (base === "sr" || base === "hr" || base === "bs" || base === "me") return "sr";
    if (supported.includes(base)) return base;
  }
  return DEFAULT_LANG;
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);
  useEffect(() => { localStorage.setItem(STORAGE_KEY, lang); document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => setLangState(LANGS.find((x) => x.code === l) ? l : DEFAULT_LANG);
  const t = (key, vars = {}) => {
    let s = (TR[lang] && TR[lang][key]) || (TR[DEFAULT_LANG] && TR[DEFAULT_LANG][key]) || key;
    Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  };
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);

// Services localized using current translations
export const useServices = () => {
  const { t } = useI18n();
  return [
    { id: "industrial", icon: "Factory", title: t("service.industrial"), short: t("service.industrial_short"),
      items: ["Razvodni ormari", "Energy monitoring", "HV installations", "Service & maintenance"] },
    { id: "home", icon: "House", title: t("service.home"), short: t("service.home_short"),
      items: ["Smart home (KNX)", "LED lighting", "Audio/Video distribution", "EV chargers"] },
    { id: "data", icon: "Network", title: t("service.data"), short: t("service.data_short"),
      items: ["CAT6A / CAT7 / Fiber", "Server racks", "Wi-Fi & LAN design", "Patch panels & KVM"] },
    { id: "security", icon: "ShieldCheck", title: t("service.security"), short: t("service.security_short"),
      items: ["Alarm & PIR", "Fire system", "Intrusion detection", "Monitoring center"] },
    { id: "access", icon: "Fingerprint", title: t("service.access"), short: t("service.access_short"),
      items: ["RFID cards", "Biometric readers", "Turnstile systems", "HR integration"] },
    { id: "cctv", icon: "Video", title: t("service.cctv"), short: t("service.cctv_short"),
      items: ["IP & PTZ cameras", "AI analytics", "NVR recording", "Remote access"] },
  ];
};

export const useStats = () => {
  const { t } = useI18n();
  return [
    { value: "12+", label: t("stats.years") },
    { value: "100+", label: t("stats.projects") },
    { value: "8", label: t("stats.countries") },
    { value: "24/7", label: t("stats.support") },
  ];
};
